import { api } from '@/lib/api/api'

export type CreateIssueRequest = {
  title: string
  description: string
  imageUrl?: string
}

export type CreateIssueResponse = {
  id: string
  message: string
  success: boolean
}

export const issueApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createIssue: builder.mutation<CreateIssueResponse, CreateIssueRequest>({
      query: (data) => ({
        url: 'v2/issues',
        method: 'POST',
        body: data,
      }),
    }),
  }),
})

export const { useCreateIssueMutation } = issueApi
